import * as common from '../apiCommon';
import * as DocType from '../../constants/constant_doc_types';

export function fetchCSVRecordForEdit(app, params) {
  const { id } = params;
  const docType = 'csv_record';
  return common.getDoc(app, { id, docType });
}

export function deleteCSVRecord(app, params) {
  const { id } = params;
  return common.deleteDoc(app, {
    id: id,
    docType: DocType.CSV_RECORD
  });
}


export function saveCSVRecord(app, dataToSave) {
  const { user = {}, data } = dataToSave;
  const customerData = {
    doc_type: DocType.CSV_RECORD,
    name: data.name,
    description: data.description,
    import_type: data.import_type,
    column_delimiter: data.column_delimiter,
    data_handling: data.data_handling,
    run_status: data.run_status,
    file_name: data.file_name
  };

  return common.saveDoc(app, {
    source: data,
    doc: customerData,
    referenceField: ['reference_id'],
    user,
  });
}


export function fetchCSVRecordById(app, params) {
  const { id } = params;
  const docType = 'csv_record';
  return common.getDoc(app, { id, docType });
}

export function startCSVImport(app, params) {
  const { id, user } = params;
  return common.getDoc(app, { id, docType: 'csv_record' })
    .then(doc => {
      return common.saveDoc(app, {
        source: doc,
        doc: { ...doc, execute: true },
        user
      });
    });
}

export async function uploadCsvFile(app, id, file) {
  const service = app.service(`csv_import/${id}`);
  const formData = new FormData();

  formData.append('csv', file);

  const result = await service.create(formData, {}, false, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });

  return result;
}
